<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-title">华华备忘录</div>
      <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0">
        <el-form-item prop="username">
          <el-input v-model="loginForm.userName" placeholder="用户名" prefix-icon="el-icon-user" @keyup.enter.native="handleLogin" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="密码" prefix-icon="el-icon-lock" @keyup.enter.native="handleLogin" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="width: 100%" :loading="loading" @click="handleLogin">登 录</el-button>
        </el-form-item>
      </el-form>
      <div style="text-align: center; margin-top: 20px;">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" style="color: #000; text-decoration: none; font-size: 12px;">粤ICP备18158737号</a>
      </div>
    </div>
  </div>
</template>

<script>
import MD5 from 'crypto-js/md5'
import { login } from '@/api/login'
import { mapActions } from 'vuex'

export default {
  name: 'LoginPage',
  data() {
    return {
      loginForm: {
        userName: '',
        password: ''
      },
      loading: false,
      rules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapActions('user', ['setToken', 'setUserInfo']),
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          // MD5-hash the password before sending to the login API
          const payload = Object.assign({}, this.loginForm, {
            password: MD5(this.loginForm.password.trim()).toString()
          })
          const res = await login(payload)
          if (res.data.code === 200 && res.data.data && res.data.data.token) {
            this.setToken(res.data.data.token)
            // 将用户信息存储到 Vuex 中，而不是 localStorage
            this.setUserInfo(res.data.data)
            localStorage.setItem('userName', res.data.data.userName)
            localStorage.setItem('isAdmin', res.data.data.isAdmin)
            // this.$message.success('登录成功')
            this.$router.replace('/')
          } else {
            this.$message.error(res.data.msg || '登录失败')
          }
        } catch (e) {
          this.$message.error('登录异常')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  min-height: 100vh;
  width: 100vw;
  /* 渐变叠加高斯模糊背景图 */
  background: linear-gradient(120deg, rgba(116,235,213,0.85) 0%, rgba(172,182,229,0.85) 100%),
    url('https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1200&q=80') center center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.login-container::before {
  content: '';
  position: absolute;
  left: 0; right: 0; top: 0; bottom: 0;
  z-index: 0;
  background: inherit;
  filter: blur(8px);
}
.login-box {
  position: relative;
  z-index: 1;
  background: rgba(255,255,255,0.95);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  padding: 48px 36px 36px 36px;
  min-width: 340px;
  display: flex;
  flex-direction: column;
  align-items: center;
  backdrop-filter: blur(2px);
}
.login-title {
  font-size: 26px;
  font-weight: bold;
  color: #409EFF;
  margin-bottom: 36px;
  letter-spacing: 2px;
  text-shadow: 0 2px 8px rgba(64,158,255,0.08);
}
.el-form {
  width: 100%;
}

</style> 